import React, { useMemo, useLayoutEffect } from 'react';
import Select from 'react-select';
import { Translate } from '@material-ui/icons';
import { Box } from '@material-ui/core';
import { useIntlManger } from '../../IntlManager';
import styles from '../../../legacy/containers/Forms/Forms.css';

const LANGUAGE = {
  en: 'English (US)',
  'en-GB': 'English (GB)',
  fr: 'Français',
  // de: 'Deutsch',
  // it: 'Italiano',
  // es: 'Español',
  vi: 'Tiếng Việt',
};
const LanguageSelector = ({
  defaultLocale,
  disabled = false,
  hide = false,
  ...rest
}) => {
  const { locale, updateLocale, supportedLocales } = useIntlManger();

  useLayoutEffect(() => {
    updateLocale(defaultLocale);
  }, [defaultLocale]);

  const options = useMemo(() => {
    return supportedLocales.map(supportedLocale => {
      return {
        label: LANGUAGE[supportedLocale] || locale,
        value: supportedLocale,
      };
    });
  }, [supportedLocales]);

  const value = { value: locale, label: LANGUAGE[locale] };
  if (hide) return null;
  return (
    <Box
      sx={{
        minWidth: 160,
        ml: 2,
        display: 'flex',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <Translate className={styles.iconTeal} />
      <Box sx={{ minWidth: 130, ml: 2 }}>
        <Select
          name="languageSelector"
          isDisabled={disabled}
          placeholder="Language"
          value={value}
          onChange={option => updateLocale(option.value)}
          options={options}
          getOptionLabel={o => o.label}
          getOptionValue={o => o.value}
          className="react-select-form-selector"
          classNamePrefix="react-select-form-selector"
          {...rest}
        />
      </Box>
    </Box>
  );
};

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/views/components/LanguageSelector/LanguageSelector.jsx